// extracted by mini-css-extract-plugin
export default {"link-wrap":"HoverBlueBorderLink_link-wrap__PTb8i","selected":"HoverBlueBorderLink_selected__1S2ko","link":"HoverBlueBorderLink_link__TWFe7"};